module.exports = __webpack_public_path__ + "img/kum-saati.1a4835fc.webp";